export function normalizeContext(text) {
  const s = String(text || '');
  if (!s) return '';
  let t = s.replace(/\r/g, '\n');
  t = t.replace(/^\s*[-–—]\s+/gm, ' ');
  t = t.replace(/\s+/g, ' ');
  t = t.replace(/\s*([.,;:!?])\s*/g, '$1 ');
  return t.trim();
}
